import React from 'react'
import { CaretRightFilled } from '@ant-design/icons'
import { images } from '../../assests/imageExport/ImageExports'
import { Link } from 'react-router-dom'

const PageHeader = ({title}) => {
  return (
    <div className='course_header mt-20'>
      <div className='left'>
        <div className='home_button'>
          <Link to={'/'} className='link'><span>Home </span></Link> <CaretRightFilled /><span> {title}</span>
        </div>
        <span><h1 className='outfit-fontfamily'>{title}</h1></span>
      </div>
      <div className='right'>
        <img src={images.books_img} alt='broken_image' className='page_header_img' />
      </div>
    </div>
  )
}

export default PageHeader
